import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { ArrowRight } from 'lucide-react';

const COPY = {
  fr: {
    eyebrow: 'Démonstration',
    title: 'Voir la plateforme sur vos propres cas',
    lede: 'La démonstration se fait en visioconférence, avec vos routes, vos tarifs et vos '
      + 'volumes. Comptez trente minutes.',
    steps: [
      {
        title: 'Enregistrer un envoi complet',
        text: 'Un client, plusieurs colis, photos et catégories de marchandise, jusqu\'à la facture.',
      },
      {
        title: 'Préparer un départ',
        text: 'Constitution du départ, chargement au scan, colis manquants signalés avant le vol.',
      },
      {
        title: 'Suivre et notifier',
        text: 'Changements de statut, messages WhatsApp et e-mail, suivi public par code.',
      },
      {
        title: 'Clôturer la livraison',
        text: 'Code de retrait, preuve photo, incident éventuel et historique du dossier.',
      },
    ],
    primary: 'Demander une démo',
    secondary: 'Créer mon entreprise',
  },
  en: {
    eyebrow: 'Demonstration',
    title: 'See the platform on your own cases',
    lede: 'The demo runs over video call, with your routes, your rates and your volumes. '
      + 'Allow thirty minutes.',
    steps: [
      {
        title: 'Register a full shipment',
        text: 'One client, several packages, photos and merchandise categories, through to the invoice.',
      },
      {
        title: 'Prepare a departure',
        text: 'Building the departure, scan loading, missing packages flagged before the flight.',
      },
      {
        title: 'Track and notify',
        text: 'Status changes, WhatsApp and email messages, public tracking by code.',
      },
      {
        title: 'Close the delivery',
        text: 'Pickup code, photo proof, incident if any, and the full record history.',
      },
    ],
    primary: 'Request a demo',
    secondary: 'Create my company',
  },
};

const DemoSection = () => {
  const { language } = useLanguage();
  const navigate = useNavigate();
  const copy = COPY[language === 'en' ? 'en' : 'fr'];

  return (
    <section id="demo" className="landing-section landing-section--alt">
      <div className="landing-section-inner">
        <span className="landing-section-eyebrow">{copy.eyebrow}</span>
        <h2 className="landing-section-title">{copy.title}</h2>
        <p className="landing-lede">{copy.lede}</p>

        <ol className="landing-steps">
          {copy.steps.map((step, i) => (
            <li key={step.title}>
              <span className="landing-step-index">{String(i + 1).padStart(2, '0')}</span>
              <div>
                <h3>{step.title}</h3>
                <p>{step.text}</p>
              </div>
            </li>
          ))}
        </ol>

        <div className="landing-actions">
          <button className="btn-primary" onClick={() => navigate('/contact')}>
            {copy.primary}
            <ArrowRight size={16} />
          </button>
          <button className="btn-secondary" onClick={() => navigate('/register-company')}>
            {copy.secondary}
          </button>
        </div>
      </div>
    </section>
  );
};

export default DemoSection;
